import { render, staticRenderFns } from "./SelectFiles.vue?vue&type=template&id=890e4398&scoped=true&"
import script from "./SelectFiles.vue?vue&type=script&lang=js&"
export * from "./SelectFiles.vue?vue&type=script&lang=js&"
import style0 from "./SelectFiles.vue?vue&type=style&index=0&id=890e4398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890e4398",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
